import { Link } from "react-router-dom";
import { Headphones, MessageCircle, Wand2, ArrowRight } from "lucide-react";
import Pricing from "@/components/Pricing";

const IMG = "https://static.prod-images.emergentagent.com/jobs/65916eb4-bab6-42d4-92ab-2a0c4102dddd/images/";

const features = [
  { icon: Headphones, title: "Écoute et suis les mots", text: "Une voix lit l'histoire et chaque mot s'illumine au bon moment.", color: "var(--sun)" },
  { icon: MessageCircle, title: "Parle et raconte", text: "Répète les phrases, explique avec tes mots et reçois des encouragements.", color: "var(--sage)" },
  { icon: Wand2, title: "Invente ton histoire", text: "Choisis un héros et un décor : l'IA écrit et illustre une histoire rien que pour toi.", color: "var(--terracotta)" },
];

export default function Landing() {
  return (
    <main data-testid="landing-page" className="mx-auto max-w-7xl px-4 pb-24 sm:px-8">
      <section className="grid items-center gap-10 pt-10 md:grid-cols-12 md:pt-16">
        <div className="rise md:col-span-6">
          <p className="mb-4 inline-block rounded-full bg-[color:var(--paper-2)] px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-[color:var(--sage)]">Pour les 3 – 8 ans</p>
          <h1 className="font-display text-5xl font-bold leading-[1.05] tracking-tight sm:text-6xl lg:text-7xl">
            Chaque histoire fait <span className="relative whitespace-nowrap text-[color:var(--terracotta)]">grandir
              <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 12" fill="none"><path d="M2 9C50 2 150 2 198 9" stroke="#F6B343" strokeWidth="5" strokeLinecap="round" /></svg>
            </span> les mots.
          </h1>
          <p className="mt-6 max-w-lg text-lg text-[color:var(--muted-ink)] sm:text-xl">
            Lis-Moi aide votre enfant à apprendre à lire et à mieux s'exprimer : histoires illustrées lues à voix haute, quiz, vocabulaire et ateliers de parole.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/connexion?mode=register" data-testid="landing-start-button" className="btn-primary">Commencer l'aventure <ArrowRight size={20} /></Link>
            <Link to="/connexion" data-testid="landing-login-button" className="btn-ghost">J'ai déjà un compte</Link>
          </div>
        </div>
        <div className="relative md:col-span-6">
          <div className="rise card-paper rotate-2 overflow-hidden p-2" style={{ animationDelay: "120ms" }}>
            <img src={IMG + "798080b0ff82e02542a23ee171764823da9e4c3b6fbeb5dbc22c4ff0c6c65c59.jpeg"} alt="Léo le renard" className="aspect-[3/2] w-full rounded-2xl object-cover" />
          </div>
          <div className="rise card-paper absolute -bottom-8 -left-4 hidden w-56 -rotate-6 overflow-hidden p-1.5 sm:block" style={{ animationDelay: "260ms" }}>
            <img src={IMG + "ddc3c1a36f60ae1dd0a37ab91a3a83b2a86ceced2391e7a72624981af7a57a9c.jpeg"} alt="Pistache le dragon" className="aspect-[3/2] w-full rounded-2xl object-cover" />
          </div>
          <div className="rise absolute -right-2 -top-6 rounded-2xl bg-[color:var(--espresso)] px-4 py-3 font-story text-lg italic text-[color:var(--paper)] shadow-xl" style={{ animationDelay: "380ms" }}>
            « Que vais-je <span className="word-active not-italic text-[color:var(--espresso)]">découvrir</span> ? »
          </div>
        </div>
      </section>

      <section className="mt-28 grid gap-6 md:grid-cols-3">
        {features.map(({ icon: Icon, title, text, color }, i) => (
          <div key={title} className="rise card-paper p-7" style={{ animationDelay: `${i * 90}ms` }}>
            <span className="mb-4 grid h-14 w-14 place-items-center rounded-2xl text-white" style={{ background: color }}><Icon size={26} /></span>
            <h3 className="font-display text-2xl font-bold">{title}</h3>
            <p className="mt-2 text-[color:var(--muted-ink)]">{text}</p>
          </div>
        ))}
      </section>

      <Pricing />
    </main>
  );
}
